import React from 'react'
import PropTypes from 'prop-types'

import styles from './inquiryConfirmation.module.scss'

const InquiryConfirmation = ({ className = '' }) => {
  return (
    <div className={`${styles.inquiryConfirmation} ${className}`}>
      <div className={styles.circle}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="43.404"
          height="32.699"
          viewBox="0 0 43.404 32.699"
        >
          <path
            d="M903.572,284.849l-3.845,3.845-5.353,5.353L889.02,299.4l-10.707-10.707-5.353,5.353,10.706,10.706,5.353,5.353,5.353-5.353,5.353-5.353,5.353-5.353,5.353-5.353,3.1-3.1-5.353-5.353"
            transform="translate(-871.547 -278.823)"
            fill="none"
            stroke="#fff"
            strokeLinecap="square"
            strokeMiterlimit="10"
            strokeWidth="2"
          />
        </svg>
      </div>

      <h3>Thank you for your request</h3>

      <p>
        We appreciate your business. A Travel Agent will contact you back shortly via phone and
        email. We look forward to serving you.
      </p>
    </div>
  )
}

InquiryConfirmation.propTypes = {
  className: PropTypes.string,
}

export { InquiryConfirmation }
